import Collapsable from "commons/card/Collapsable";
import ArrayFormatter from "commons/filters/ArrayFormatter";
import * as dates from "commons/models/dates";
import HotFolderModal from "pages/hot/modals/HotFolderModal";
import ModifyFileModal from "pages/hot/modals/ModifyFileModal";
import Toolbar from "pages/tables/components/Toolbar";
import GenericGrid from "pages/tables/GenericGrid";
import Planification from "../Infos/Planification";
import ProduitsAssignes from "./ProduitsAssignes";
import PropTypes from "prop-types";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import "scss/_tablePage.scss";
import Note from "./Note";
import LoaderContainer from "commons/container/LoaderContainer";
import { useSearchParams } from "react-router-dom";
import CreatePlanification from "../Infos/CreatePlanification";
import CustomScheduler from "commons/filters/CustomScheduler";
import { Numerique } from "pages/gant/constantes/medias";
import CampagneToolbar from "pages/tables/components/CampagneToolbar";
import { copy } from "commons/models/list";
import { useAppSelector } from "../../../../redux/store";
import {
  useGetCampagneNotesQuery,
  useGetCampagneReqQuery,
  useGetCampagneTypeProdQuery,
  useGetDiffuseursQuery,
  useGetDocumentsQuery,
  useGetThematiqueQuery,
  useLazyGetTreqQuery,
  useRemoveDocumentMutation,
} from "../../../../redux/api/cache";

export default function ArrayTabFiles(props) {
  let buttonsState = useAppSelector((state) => state.appState.buttonsState);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [selectedDocRow, setSelectedDocRow] = useState(undefined);
  const [InfosVisible, setInfosVisible] = useState(false);
  const [hotFolderModalVisible, setHotFolderModalVisible] = useState(false);
  const [documentModalVisible, setDocumentModalVisible] = useState(false);
  const [documentUrlParameters, setDocumentUrlParameters] = useState({});
  const [base64Xlsx, setBase64Xlsx] = useState(undefined);
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [getTreq] = useLazyGetTreqQuery();
  const [removeDocument] = useRemoveDocumentMutation();
  const [completeDocumentUrl, setCompleteDocumentUrl] = useState(undefined);
  const [notesParams, setNotesParams] = useState("");
  const [campagneReqDate, setCampagneReqDate] = useState("");
  const {
    data: documents,
    isLoading: isDocumentsLoading,
    isFetching: isDocumentsFetching,
  } = useGetDocumentsQuery(
    {
      seq: props.project.camp_seq,
      media: props.mediaKey,
      params: completeDocumentUrl,
    },
    { skip: !completeDocumentUrl }
  );
  const {
    data: notes,
    isLoading: isNotesLoading,
    isFetching: isNotesFetching,
  } = useGetCampagneNotesQuery(
    { seq: props.project.camp_seq, media: props.mediaKey, params: notesParams },
    { skip: !notesParams }
  );
  const { data: thematiques } = useGetThematiqueQuery();
  const { data: diffuseurs } = useGetDiffuseursQuery(props.mediaKey);
  const [diffuseur, setDiffuseur] = useState("");
  const [thematique, setThematique] = useState("");
  const [format, setFormat] = useState("");
  const {
    data: campagnes,
    isLoading: campagneReqLoading,
    isFetching: campagneReqFetching,
  } = useGetCampagneReqQuery(
    {
      seq: props.project.camp_seq,
      media: props.mediaKey,
      date: campagneReqDate,
      diff: diffuseur,
      them_cd: thematique,
      mf_format: format,
    },
    { skip: !campagneReqDate || (!diffuseur && !thematique) }
  );
  const getFormattedDate = (date) => {
    if (!date) return "";

    let splitDate = date.split("-");
    return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
  };

  const {
    data: produits,
    isLoading: isProduitsLoading,
    isFetching: isProduitsFetching,
  } = useGetCampagneTypeProdQuery({
    camp_seq: selectedRow?.camp_seq,
    media_cd: selectedRow?.media_cd,
    diff_cd: selectedRow?.diff_cd,
    div_num: 0,
    campr_date: getFormattedDate(selectedRow?.campr_date),
    them_cd: selectedRow?.them_cd,
  });

  useEffect(() => {
    const updateCampagne = async () => {
      let campagne = searchParams.get("campagne");
      if (campagne && props.data.data.length > 0) {
        let targetRow = props.data.data.find(
          (row) => row.rid.toString() === campagne
        );
        if (targetRow)
          await outputData({
            campr_date: targetRow.campr_date,
            diff_cd: targetRow.diff_cd,
            them_cd: targetRow.them_cd,
            campr_dt_limite: targetRow.campr_dt_limite,
            mf_format: targetRow.mf_format,
          });
      } else {
        setSelectedRow(undefined);
      }
    };
    updateCampagne();
  }, [props.data.data, searchParams]);

  useEffect(() => {
    let document = searchParams.get("document");

    if (document && documents !== undefined) {
      let doc = documents.data.find((e) => e.rid.toString() === document);
      if (doc) {
        setSelectedDocRow(doc);
        setDocumentModalVisible(true);
      }
    }
  }, [documents, searchParams]);

  const setDocumentsParams = (arrayFormatterSelectedValues) => {
    let copiedArrayFormatterSelectedValues = {
      ...arrayFormatterSelectedValues,
    };
    setDocumentUrlParameters({
      ...{
        camp_seq: props.project.camp_seq,
        media_cd: props.mediaKey,
        from: "publicite",
      },
      ...copiedArrayFormatterSelectedValues,
    });

    if (props.documentUrlParameters !== undefined) {
      let completeDocumentUrl = dates.documentUrlParameters(
        props.documentUrlParameters,
        arrayFormatterSelectedValues
      );

      setCompleteDocumentUrl(completeDocumentUrl);
    }
  };

  const loadNotes = async (arrayFormatterSelectedValues) => {
    let params = "";
    for (const property in arrayFormatterSelectedValues) {
      if (arrayFormatterSelectedValues[property]) {
        if (property?.includes("date")) {
          let date = dates.dateQueryFormatReverse(
            arrayFormatterSelectedValues[property]
          );
          params += `${property}=${date}&`;
        } else
          params += `${property}=${arrayFormatterSelectedValues[property]}&`;
      }
    }
    setNotesParams(params);
  };

  const campaignClick = async (project) => {
    setSelectedRow(project);
    setInfosVisible(true);
  };

  useEffect(() => {
    if (campagnes && campagnes.data) campaignClick(campagnes.data[0]);
  }, [campagnes]);

  const generateTreq = async () => {
    setBase64Xlsx(undefined);
    let result = await getTreq(props.project.camp_seq).unwrap();
    if (result) {
      setBase64Xlsx(
        `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${result}`
      );
      window.open(
        `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${result}`,
        "_blank"
      );
    }
  };

  const loadReqPage = async (values) => {
    if (values.campr_date && !values.campr_date.includes("/")) {
      setCampagneReqDate(getFormattedDate(values.campr_date));
    }

    setDiffuseur(values.diff_cd);
    setThematique(values.them_cd);
    setFormat(values.mf_format);
  };

  const outputData = async (e) => {
    setDocumentsParams(e);
    await loadNotes(e);
    await loadReqPage(e);
  };

  const getCurrentSelectionTitle = () => {
    return selectedRow
      ? `(${
          selectedRow.diff_cd
            ? diffuseurs.data.find((d) => d.diff_cd === selectedRow.diff_cd)
                ?.diff_nom
            : thematiques.data.find((d) => d.them_cd === selectedRow.them_cd)
                ?.them_descr
        } le ${selectedRow.campr_date})`
      : "";
  };

  const handleOutputData = useCallback(async (e) => {
    await outputData(e);
    searchParams.set("campagne", e.rid);
    setSearchParams(searchParams, { replace: true });
  }, []);

  return (
    <Fragment>
      <Fragment>
        {showAddModal && (
          <CreatePlanification
            {...props}
            setShowAddModal={setShowAddModal}
            media={props.mediaKey}
            camp_seq={props.project.camp_seq}
          />
        )}
        <CampagneToolbar buttonsState={buttonsState} />
        {buttonsState.buttons && (
          <ArrayFormatter
            outputData={(e) => handleOutputData(e)}
            data={props.data}
            media={props.mediaKey}
            show={true}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            numeric={props.mediaKey === Numerique}
          />
        )}
        {buttonsState.calendar && (
          <CustomScheduler
            data={props.data.data}
            media={props.mediaKey}
            outputData={(e) => handleOutputData(e)}
            numeric={props.mediaKey === Numerique}
            selectedRow={selectedRow}
          />
        )}
        <Toolbar
          showCreateBtn={true}
          txtBtn={"Ajouter une planification"}
          onCreateClick={() => setShowAddModal(true)}
          showCreateBtn2={false}
          //TODO À remettre showCreateBtn2={props.mediaKey === Numerique}
          txtBtn2="Générer le TREQ"
          onCreateClick2={generateTreq}
        ></Toolbar>
        <div>
          {!campagneReqLoading &&
            !campagneReqFetching &&
            InfosVisible &&
            campagnes &&
            documents && (
              <Collapsable
                title={`Informations ${getCurrentSelectionTitle()}`}
                expanded={true}
              >
                <Planification
                  media={props.mediaKey}
                  camp_seq={props.project.camp_seq}
                  gridData={copy(campagnes)}
                  selectedRow={selectedRow}
                  project={props.project}
                  documents={documents}
                />
              </Collapsable>
            )}
          {!isProduitsLoading &&
            !isProduitsFetching &&
            InfosVisible &&
            selectedRow &&
            produits && (
              <Collapsable
                title={`Produits assignés ${getCurrentSelectionTitle()}`}
                expanded={true}
              >
                <ProduitsAssignes
                  enableCheckbox={"camprp_affiche"}
                  global={false}
                  data={produits}
                  infos={selectedRow}
                />
              </Collapsable>
            )}
          {(campagneReqLoading || campagneReqFetching) && <LoaderContainer />}
          {(isProduitsLoading || isProduitsFetching) && <LoaderContainer />}
        </div>
      </Fragment>

      {hotFolderModalVisible && (
        <HotFolderModal
          onClose={() => setHotFolderModalVisible(!hotFolderModalVisible)}
          onSave={async () => {
            setHotFolderModalVisible(false);
          }}
          params={documentUrlParameters}
          camp_num={props.project.camp_num}
          showForm={true}
        />
      )}
      {documentModalVisible && (
        <ModifyFileModal
          selectedDocRow={selectedDocRow}
          toggleDialog={() => setDocumentModalVisible(false)}
        />
      )}

      {!isDocumentsLoading &&
        !isDocumentsFetching &&
        InfosVisible &&
        documents &&
        selectedRow && (
          <Collapsable
            title={`Documents ${getCurrentSelectionTitle()}`}
            expanded={true}
          >
            <GenericGrid
              autoSize={true}
              showCreateBtn={true}
              onCreateClick={() => setHotFolderModalVisible(true)}
              definition={documents.meta.definition}
              txtBtn="Ajouter un document"
              data={documents.data}
              documentsUrlParameters={documentUrlParameters}
              showDocumentsButtonsCell={true}
              removeFile={async (ridDocument) => {
                await removeDocument(ridDocument);
              }}
            ></GenericGrid>
          </Collapsable>
        )}
      {(isDocumentsLoading || isDocumentsFetching) && <LoaderContainer />}
      {!isNotesLoading &&
        !isNotesFetching &&
        InfosVisible &&
        notes &&
        props.data &&
        props.data.data.length > 0 &&
        selectedRow && (
          <Collapsable
            title={`Notes ${getCurrentSelectionTitle()}`}
            expanded={true}
          >
            <Note
              mediaKey={props.mediaKey}
              project={selectedRow}
              data={notes}
              showAddButton={true}
            ></Note>
          </Collapsable>
        )}
      {(isNotesLoading || isNotesFetching) && <LoaderContainer />}
    </Fragment>
  );
}

ArrayTabFiles.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.shape({
      definition: PropTypes.array,
    }),
  }),
  documentUrlParameters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      uri: PropTypes.string.isRequired,
    })
  ),
  mediaKey: PropTypes.string,
  project: PropTypes.shape({
    camp_seq: PropTypes.any,
    camp_num: PropTypes.any,
  }),
};
